<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ 'MED_REVIEW.CONFIGS' | translate }}</h3>
    </div>
  </div>
  <div style="min-height: 300px !important" class="card-body">
    <div class="d-flex mb-4">
      <div class="flex-grow-1 d-flex align-items-stretch">
        <div class="w-50">
          <mat-form-field
            appearance="fill"
            [matTooltip]="configKeys.length ? null : 'All keys added!'"
            [matTooltipPosition]="'above'"
          >
            <mat-label>Key</mat-label>
            <mat-select #key>
              <mat-option *ngFor="let k of configKeys" [value]="k">{{
                k | enumFormat : '_'
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="w-50 ml-4">
          <mat-form-field
            *ngIf="key.value !== MedReviewConfigKey.RELATED_TASK_TEMPLATES"
            appearance="fill"
          >
            <mat-label>Value</mat-label>
            <input #value matInput type="text" />
          </mat-form-field>
          <kt-general-autocomplete
            *ngIf="key.value === MedReviewConfigKey.RELATED_TASK_TEMPLATES"
            #templatesAutocomplete
            [label]="'Value'"
            [chipList]="true"
            [dataPath]="'data'"
            [objects]="templatesAutocomplete.value"
            [loadItemsFunction]="getTemplateAutocomplete$"
            [optionFormatter]="formatTemplateOption"
            [valueFormatter]="formatTemplateOption"
            [formatNewObjectFn]="formatNewTemplate"
          ></kt-general-autocomplete>
        </div>
      </div>
      <div [matTooltip]="!key.value ? 'Add Key!' : 'Add'" [matTooltipPosition]="'above'">
        <button
          [disabled]="!key.value"
          class="btn btn-icon btn-light btn-hover-success btn-sm ml-4"
          (click)="addConfig($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Navigation/Plus.svg"
            class="svg-icon svg-icon-md svg-icon-success"
          ></span>
        </button>
      </div>
      <div matTooltip="Reset" [matTooltipPosition]="'above'">
        <button
          [disabled]="!key.value"
          class="btn btn-icon btn-light btn-hover-success btn-sm ml-2"
          (click)="reset($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/reset.svg"
            class="svg-icon svg-icon-md svg-icon-success"
          ></span>
        </button>
      </div>
    </div>
    <div>
      <div
        class="d-flex align-items-stretch border border-secondary rounded font-weight-bold p-2 mb-2"
      >
        <div class="flex-grow-1 d-flex align-items-center">
          <div class="w-50 px-2">Key</div>
          <div class="w-50 px-2">Value</div>
        </div>
        <div style="min-width: 85px !important" class="px-2">Actions</div>
      </div>
      <div>
        <div
          *ngIf="!configs.length"
          style="height: 80px !important"
          class="d-flex flex-center font-weight-bold"
        >
          No Configurations Added!
        </div>
        <div
          *ngFor="let config of configs; let idx = index"
          class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1"
        >
          <div class="flex-grow-1 d-flex align-items-center">
            <div class="w-50 px-2">{{ config.key | enumFormat : '_' }}</div>
            <div class="w-50 px-2">{{ formatConfig(config) }}</div>
          </div>
          <div style="min-width: 85px !important" class="px-2">
            <button
              [matTooltip]="'TABLE.UPDATE' | translate"
              [disabled]="!!key.value"
              class="btn btn-icon btn-light btn-hover-primary btn-sm"
              (click)="updateConfig($event, idx, config)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              [matTooltip]="'TABLE.DELETE' | translate"
              [disabled]="!!key.value"
              class="btn btn-icon btn-light btn-hover-danger btn-sm ml-2"
              (click)="deleteConfig($event, idx)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
